export const Notes = require('./Notesite.png')
export const Ecommerce = require('./Ecommerce.png')
export const FakeUtube = require('./Fakeutube.png')
export const Todo = require('./Todo.png')
export const Hospital = require('./HospitalDashboard.png')
export const Auction = require('./Auction.png')
export const Epicmovies = require('./EpicMovies.png')
export const Matrimony = require('./Matrimony.png')